import styled, { css } from 'styled-components';

type FielWrapperProps = {
  desktopWidthIsShort?: boolean;
  tabletWidthIsShort?: boolean;
};

export const errorStyles = css`
  color: red;
  margin: 5px 0 !important;
`;

export const serverErrorStyles = css`
  color: red;
  margin-top: 0px !important;
  margin-bottom: 0px !important;
  text-align: center;
`;

export const formContainerStyles = css`
  .form__label {
    font-size: 20px;
  }
  .form__input,
  .form__input::placeholder {
    font-size: 18px;
  }
  .ctaButton-wrapper {
    margin-top: 20px;
  }
  .hint-message a {
    display: inline;
  }
`;

export const timeSlotHintStyles = css`
  font-weight: bold;
  font-size: 20px;
`;

const desktopShortFullWidthStyles = css`
  @media only screen and (min-width: 1100px) {
    width: 40%;
    margin: auto;
    text-align: start;
  }
`;

const tabletShortFullWidthStyles = css`
  @media only screen and (min-width: 900px) and (max-width: 1100px) {
    width: 60%;
    margin: auto;
    text-align: start;
  }

  @media only screen and (min-width: 600px) and (max-width: 899px) {
    width: 70%;
    margin: auto;
    text-align: start;
  }
`;

export const ButtonWrapper = styled.div`
  [class*='SimpleGridstyle__SimpleGridColumn-sc'] {
    width: auto;
  }
`;

export const FieldWrapper = styled.div<FielWrapperProps>`
  ${({ desktopWidthIsShort }) =>
    desktopWidthIsShort && desktopShortFullWidthStyles}
  ${({ tabletWidthIsShort }) =>
    tabletWidthIsShort && tabletShortFullWidthStyles}
  
  textarea {
    height: auto;
  }
  .small {
    font-size: 1rem;
  }

  [class^='Checkbox'] {
    [class^='Checkbox'] {
      label {
        margin-right: 0;
        margin-inline-end: 2rem;
      }
    }
  }  
`;
